<template>
  <div class="hub-page">
    <div class="hub-container">

      <!-- HEADER -->
      <div class="hub-header">
        <h2 class="hub-title">
          <b-icon icon="pie-chart-fill" class="mr-2"></b-icon>
          {{ $t("Hisobotlar") }}
        </h2>
        <top></top>
      </div>

      <!-- HISOBOT KARTOCHKALARI -->
      <div class="hub-grid">
        <router-link
          v-for="(rep, idx) in reports"
          :key="rep.path"
          :to="rep.path"
          class="hub-card"
          :class="['hub-tone-' + (idx % 6 + 1), { 'hub-stub': rep.stub }]"
        >
          <div class="hub-icon-wrap">
            <b-icon :icon="rep.icon"></b-icon>
          </div>
          <div class="hub-body">
            <div class="hub-num">{{ rep.code }}</div>
            <div class="hub-name">{{ rep.title }}</div>
            <div class="hub-desc">{{ rep.desc }}</div>
            <span v-if="rep.stub" class="hub-stub-badge">Tez orada</span>
            <span v-else class="hub-ready-badge">Tayyor</span>
          </div>
          <div class="hub-arrow">
            <b-icon icon="arrow-right-circle"></b-icon>
          </div>
        </router-link>
      </div>

    </div>

    <!--
      ============ ESKI HISOBOTLAR (qoldirildi referens uchun) ============
      Mavjud rules-based dinamik menu yashirildi. Yangi hub yuqorida.
      Kerak bo'lsa eski hisobotlarga to'g'ridan-to'g'ri URL orqali kirish mumkin
      (masalan /xisobot/product, /xisobot/kassa va h.k. — Xisobot/Xisobot/ ichidagi sahifalar).

      <div class="row xisobot" v-if="rules.length>0">
        <div>
          <label for="">Otchet tovari</label>
          ...
        </div>
      </div>
    -->
  </div>
</template>

<script>
import Top from "../Layout/Top.vue";

export default {
  name: 'HisobotHub',
  components: { Top },
  data() {
    return {
      reports: [
        { code: '2.1', title: "Kassa Kirim/Chiqim",        desc: "Sana va to'lov turlari bo'yicha kassa harakati", path: '/xisobot/kassa-flow',     icon: 'wallet-fill',            stub: false },
        { code: '★',   title: "Kassa Sverkasi",            desc: "Barcha tranzaksiyalar logi (sana, doc, summa)", path: '/xisobot/kassa-sverka',   icon: 'list-columns-reverse',   stub: false },
        { code: '2.1+',title: "Kassa yopish",              desc: "Kun yakuni: kassa, foizli ishlar va fiksa",      path: '/xisobot/kassa-closing',  icon: 'clipboard-check',        stub: false },
        { code: '2.2', title: "Kassa Hisoboti",            desc: "Kassa qoldig'i, naqd va dollar balansi",        path: '/xisobot/kassa-summary',  icon: 'cash-stack',             stub: false },
        { code: '2.3', title: "Mijozlar qarz hisoboti",    desc: "Qarz oldi/berdi, balans mijozlar kesimida",     path: '/xisobot/clients-debt',   icon: 'people-fill',            stub: false },
        { code: '2.4', title: "Ta'minotchi hisoboti",      desc: "Ta'minotchilar bilan hisob-kitob",              path: '/xisobot/suppliers',      icon: 'truck',                  stub: false },
        { code: '2.5', title: "Service foyda zarari",      desc: "Xizmatlar bo'yicha daromad va xarajat",         path: '/xisobot/service-profit', icon: 'gear-fill',              stub: false },
        { code: '2.6', title: "Xodimlar oylik",            desc: "Xodimlarga to'langan oylik va bonus",           path: '/xisobot/staff-salary',   icon: 'person-badge',           stub: false },
        { code: '2.7', title: "Ustalar oylik",             desc: "Ustalar bo'yicha foyda, oylik va to'lovlar",    path: '/xisobot/masters',        icon: 'tools',                  stub: false },
        { code: '2.8', title: "Umumiy foyda zarar",        desc: "Jami kirim - jami chiqim, diagramma bilan",     path: '/xisobot/profit-loss',    icon: 'graph-up-arrow',         stub: false },
        { code: '2.9', title: "Mahsulot foyda zarari",     desc: "Mahsulot sotuvi va tannarx farqi",              path: '/xisobot/product-profit', icon: 'box-seam-fill',          stub: false },
        { code: '2.9+',title: "Partiya (seriya) hisoboti", desc: "Kirim/papka bo'yicha: keldi, tushgan narx, sotildi, foyda, qoldiq", path: '/xisobot/partiya', icon: 'bar-chart-line', stub: false },
        { code: '2.10',title: "Mahsulot ombor hisoboti",   desc: "Qoldiq, tannarx, sotish narxi, jami",           path: '/xisobot/product-stock',  icon: 'boxes',                  stub: false },
        { code: '2.11',title: "Zakaslar hisoboti",         desc: "Buyurtmalar holati, sana, mijoz, summa",        path: '/xisobot/orders',         icon: 'journal-check',          stub: false },
        { code: '+',   title: "Top mahsulot va xizmatlar", desc: "Eng ko'p sotilgan mahsulot/xizmat ro'yxati",    path: '/xisobot/top',            icon: 'trophy-fill',            stub: false },
        { code: '★',   title: "Narxnoma (PDF)",            desc: "Kirim qilingan mahsulotlar optom/chakana narxnomasi", path: '/xisobot/narxnoma', icon: 'file-earmark-pdf-fill', stub: false },
      ]
    };
  }
};
</script>

<style scoped>
.hub-page {
  padding: 24px;
  background: #f4f7f9;
  min-height: calc(100vh - 56px);
  overflow-y: auto;
  height: calc(100vh - 56px);
}

.hub-container {
  max-width: 1400px;
  margin: 0 auto;
}

.hub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.hub-title {
  font-weight: 800;
  font-size: 26px;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
}

.hub-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
  gap: 16px;
}

.hub-card {
  background: white;
  border-radius: 18px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none !important;
  color: #0f172a;
  border: 1px solid #f1f5f9;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);
  transition: 0.25s;
  position: relative;
}

.hub-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.08);
  border-color: #a142f4;
}

.hub-card.hub-stub { opacity: 0.78; }
.hub-card.hub-stub:hover { opacity: 1; }

.hub-icon-wrap {
  width: 54px;
  height: 54px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 24px;
  color: white;
}

.hub-tone-1 .hub-icon-wrap { background: linear-gradient(135deg, #a142f4, #8b2cf5); }
.hub-tone-2 .hub-icon-wrap { background: linear-gradient(135deg, #10b981, #059669); }
.hub-tone-3 .hub-icon-wrap { background: linear-gradient(135deg, #2563eb, #1d4ed8); }
.hub-tone-4 .hub-icon-wrap { background: linear-gradient(135deg, #f59e0b, #d97706); }
.hub-tone-5 .hub-icon-wrap { background: linear-gradient(135deg, #06b6d4, #0891b2); }
.hub-tone-6 .hub-icon-wrap { background: linear-gradient(135deg, #e11d48, #be123c); }

.hub-body {
  flex: 1;
  min-width: 0;
}

.hub-num {
  font-size: 10px;
  font-weight: 800;
  color: #94a3b8;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.hub-name {
  font-weight: 800;
  font-size: 15px;
  color: #0f172a;
  margin-bottom: 4px;
}

.hub-desc {
  font-size: 11px;
  color: #64748b;
  line-height: 1.4;
  margin-bottom: 6px;
}

.hub-stub-badge {
  display: inline-block;
  background: #fef3c7;
  color: #b45309;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 10px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.hub-ready-badge {
  display: inline-block;
  background: #dcfce7;
  color: #16a34a;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 10px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.hub-arrow {
  color: #cbd5e1;
  font-size: 22px;
  flex-shrink: 0;
}

.hub-card:hover .hub-arrow {
  color: #a142f4;
}

@media (max-width: 575px) {
  .hub-page { padding: 12px; }
  .hub-grid { grid-template-columns: 1fr; }
}
</style>
